import React, { Component } from 'react'
import { apiConfiguration, apiAwards } from 'helpers/decorators/api'
import { meta, permissions, tableCommon } from 'helpers/decorators'
import { CONFIGURATION_KEYS } from '../../../constants/enums'
import { connect } from 'react-redux'
import { awards as awardApi } from '../../../redux/modules/api'
import { AwardsOverviewTable } from '../../../components/sections/awards'
import FilterAwardsOverview
  from '../../filters/FilterAwardsOverview/FilterAwardsOverview'

@meta({
  title: 'Awards Overview',
  intlKey: 'pageTitle.awards_overview'
})
@permissions()
@apiConfiguration({
  getValues: [
    CONFIGURATION_KEYS.enableLabels.id
  ]
})
@apiAwards({
  listOverview: true,
  useCommonLimit: true
})
@tableCommon()
@connect(
    ({ auth }) => ({
      activeOrganization: auth.organization
    }),
    { setFilter: awardApi.setAwardsOverviewFilter }
)
class AwardsRegistrationGrid extends Component {
  render() {
    return (
      <div>
        <FilterAwardsOverview />
        <AwardsOverviewTable {...this.props} />
      </div>
    )
  }
}

export default AwardsRegistrationGrid
